export default __webpack_public_path__ + "static/media/FAO_logo_White_2lines_en.a0765f79.svg";